import { useState, useEffect } from 'react'
import styled from 'styled-components'
import BounceUp from 'common/animations/bounce-up'
import { TransparentButton, SecondaryButton } from 'common/button'
import { MdClose } from 'react-icons/md'
import { useRouter } from 'next/router'

const NewsletterInvitationStyled = styled.div`
  position: fixed;
  bottom: 16px;
  right: 16px;
  left: 16px;
  .invitation-container {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
  .close-invitation {
    margin-bottom: 16px;
  }
  @media (min-width: 768px) {
    left: auto;
    bottom: 64px;
    right: 64px;
    .close-invitation {
      margin-bottom: 8px;
    }
  }
`

function NewsletterInvitation() {
  const [show, setShow] = useState(false)
  const { query: { invitation } } = useRouter()
  useEffect(() => {
    // Set the time to be show by params or 3 minutes
    // 3 * 60 * 1000  = 180 000
    const time = parseInt(invitation, 10) || 180000
    const timeout = setTimeout(() => setShow(true), time)
    return () => {
      if (!invitation) {
        clearTimeout(timeout)
      }
    }
  }, [invitation])
  return (
    <NewsletterInvitationStyled>
      <BounceUp show={show}>
        <div className="invitation-container" id="newsletter-invitation">
          <TransparentButton onClick={() => setShow(false)} className="close-invitation">
            <MdClose color="var(--lightBlue)" size="20" />
          </TransparentButton>
          <SecondaryButton
            href="#newsletter"
            as="a"
            onClick={() => setShow(false)}
            fitContent
            fullWidth
          >
            Suscribete al newsletter
          </SecondaryButton>
        </div>
      </BounceUp>
    </NewsletterInvitationStyled>
  )
}

export default NewsletterInvitation
